var map = {
	"./Logo.png": "./src/assets/images/Logo.png",
	"./body.jpg": "./src/assets/images/body.jpg",
	"./coolturist_logo.png": "./src/assets/images/coolturist_logo.png",
	"./download.png": "./src/assets/images/download.png",
	"./favicon.png": "./src/assets/images/favicon.png",
	"./header.jpg": "./src/assets/images/header.jpg",
	"./languages/gb.png": "./src/assets/images/languages/gb.png",
	"./languages/hr.png": "./src/assets/images/languages/hr.png",
	"./map-point-pointer.png": "./src/assets/images/map-point-pointer.png",
	"./movie-clapper-open-small.png": "./src/assets/images/movie-clapper-open-small.png",
	"./nova.png": "./src/assets/images/nova.png",
	"./social/facebook.png": "./src/assets/images/social/facebook.png",
	"./social/instagram.png": "./src/assets/images/social/instagram.png",
	"./social/twitter.png": "./src/assets/images/social/twitter.png",
	"./social/youtube.png": "./src/assets/images/social/youtube.png",
	"./sponzori/CO-logo-big.png": "./src/assets/images/sponzori/CO-logo-big.png",
	"./sponzori/CO-logo.png": "./src/assets/images/sponzori/CO-logo.png",
	"./sponzori/HEP-logo-small.png": "./src/assets/images/sponzori/HEP-logo-small.png",
	"./sponzori/HVAR.png": "./src/assets/images/sponzori/HVAR.png",
	"./sponzori/HVAR_150.png": "./src/assets/images/sponzori/HVAR_150.png",
	"./sponzori/JL-logo-small.png": "./src/assets/images/sponzori/JL-logo-small.png",
	"./sponzori/PBZ-logo-big.png": "./src/assets/images/sponzori/PBZ-logo-big.png",
	"./sponzori/PBZ-logo.png": "./src/assets/images/sponzori/PBZ-logo.png",
	"./sponzori/PBZ-o-logo.png": "./src/assets/images/sponzori/PBZ-o-logo.png",
	"./sponzori/TZJ-logo-small.png": "./src/assets/images/sponzori/TZJ-logo-small.png",
	"./sponzori/TZSN-logo-small.png": "./src/assets/images/sponzori/TZSN-logo-small.png",
	"./sponzori/TZ_HVAR.png": "./src/assets/images/sponzori/TZ_HVAR.png",
	"./sponzori/TZ_Rijeka.png": "./src/assets/images/sponzori/TZ_Rijeka.png",
	"./sponzori/grad-porec.png": "./src/assets/images/sponzori/grad-porec.png",
	"./sponzori/headline-logo.png": "./src/assets/images/sponzori/headline-logo.png",
	"./sponzori/hep-logo.png": "./src/assets/images/sponzori/hep-logo.png",
	"./sponzori/jadro-logo.png": "./src/assets/images/sponzori/jadro-logo.png",
	"./sponzori/porec.png": "./src/assets/images/sponzori/porec.png",
	"./sponzori/rijeka_2020.png": "./src/assets/images/sponzori/rijeka_2020.png",
	"./sponzori/selca_logo.png": "./src/assets/images/sponzori/selca_logo.png",
	"./sponzori/selca_sumartin.png": "./src/assets/images/sponzori/selca_sumartin.png",
	"./sponzori/tar.png": "./src/assets/images/sponzori/tar.png",
	"./sponzori/tz_dubrovnik.png": "./src/assets/images/sponzori/tz_dubrovnik.png",
	"./sponzori/tz_dubrovnik_airport.png": "./src/assets/images/sponzori/tz_dubrovnik_airport.png",
	"./sponzori/tz_ston.png": "./src/assets/images/sponzori/tz_ston.png",
	"./sponzori/tz_svlaho.png": "./src/assets/images/sponzori/tz_svlaho.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive \\.(png|jpg)$";